var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-picker',_vm._b({attrs:{"value-type":"format","lang":"en"},on:{"change":_vm.setDateUTC},model:{value:(_vm.internalDate),callback:function ($$v) {_vm.internalDate=$$v},expression:"internalDate"}},'date-picker',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }